import { useContext } from 'react';
import { SendToAssistantContext } from '../context/SendToAssistantProvider';

export const useSentPrompts = () => {
  const { sentPrompts, clearSentPrompt } = useContext(SendToAssistantContext);
  return { sentPrompts, clearSentPrompt };
};

export const useSendToAssistant = () => {
  const { sendToAssistant, clearSentPrompt } = useContext(SendToAssistantContext);
  return { sendToAssistant, clearSentPrompt };
};
